// @flow

import { MDXProvider as SourceMDXProvider } from '@mdx-js/react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import * as React from 'react'
import type { Mdx } from 'types'

import { List, text } from '@toggl/ui'

import { FTECalculator } from './addons/FTECalculator'
import { MDXCallToAction } from './addons/MDXCallToAction'
import { TimeCardCalculator } from './addons/TimeCardCalculator'
import { Timer } from './addons/Timer'
import { useAssets } from './hooks/useAssets'
import { Link } from './Link'

export const MDXProvider = ({
  children,
}: {
  children?: React.Node,
}): React.Element<typeof SourceMDXProvider> => (
  <SourceMDXProvider
    components={{
      a: Link,
      h1: text.H1,
      h2: text.H2,
      h3: text.H3,
      h4: text.H4,
      h5: text.H5,
      img: Img,
      li: List.Item,
      strong: text.Strong,
      ul: List.Wrapper,
      FTECalculator,
      TimeCardCalculator,
      MDXCallToAction,
      Timer,
    }}
  >
    {children}
  </SourceMDXProvider>
)

export const MDX = ({
  p,
  italic,
  children,
}: {
  p?: React.ComponentType<any>,
  italic?: React.ComponentType<any>,
  children: Mdx,
}): React.Element<typeof SourceMDXProvider> => {
  if (typeof children !== 'object' || children?.body == null) {
    throw new Error(
      'Unexpectedly received something that is not compiled MDX. Check the schema or page data for changes.'
    )
  }

  return (
    <SourceMDXProvider
      components={{
        p: p ?? text.P1,
        italic: italic ?? text.P1,
      }}
    >
      <MDXRenderer>{children.body}</MDXRenderer>
    </SourceMDXProvider>
  )
}

const Img = ({
  children,
  src,
  ...rest
}: {
  children?: React.Node,
  src?: string,
  ...
}): React.Element<'img'> => {
  const { asset } = useAssets({ asset: src })

  return (
    <img {...rest} src={asset ?? src}>
      {children}
    </img>
  )
}
